const Menu = [
  {
    label: 'Home',
    pathname: '/admin',
  },
  {
    label: 'Sign-up',
    pathname: '/admin/member',
  },
  {
    label: 'Free Paper',
    pathname: '/admin/paper',
  },
  {
    label: 'Free Paper Review',
    pathname: '/admin/paper/review',
  },
  {
    label: 'Speaker Abstract',
    pathname: '/admin/speaker',
  },
  {
    label: 'Registration',
    pathname: '/admin/registration',
  },
  {
    label: 'Sponsor',
    pathname: '/admin/sponsor',
  },
  {
    label: 'Status',
    pathname: '/admin/status',
  },
];

export default Menu;
